export const ROUTES = {
  OAUTH_CALLBACK: '/oauth/callback',
  LOGIN: '/login',
  HOME: '/',
  QR: '/qr',
  DOWNLOAD: '/download',
  INTRO: '/intro',
  BOOK_SEARCH: '/books',
  BOOK_DETAIL: '/books',
  LIBRARY: '/library',
  MEMBER_LIBRARY: '/members/:memberId/library',
  FEED: '/feed',
};
